import { A11yModule } from '@angular/cdk/a11y';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AlertComponent } from './components/alert/alert.component';
import { NeoButtonComponent } from './components/button/button.component';
import { NeoChipComponent } from './components/chip/chip.component';
import { ConfirmDialogComponent } from './components/confirm-dialogue/confirm-dialog.component';
import { HeaderComponent } from './components/header/header.component';
import { NeoCardListComponent } from './components/neo-card-list/neo-card-list.component';
import { NeoCardComponent } from './components/neo-card/neo-card.component';
import { NeoFlyoutFilterComponent } from './components/neo-flyout-filter/neo-flyout-filter.component';
import { NeoMediaViewerComponent } from './components/neo-media-viewer/neo-media-viewer.component';
import { NeoMultiSelectComponent } from './components/neo-multi-select/neo-multi-select.component';
import { NeoSignaturePadComponent } from './components/neo-signature-pad/neo-signature-pad.component';
import { NeoTableComponent } from './components/neo-table/neo-table.component';
import { NeoToggleButtonComponent } from './components/neo-toggle-button/neo-toggle-button.component';
import { NeoTriStateToggleComponent } from './components/neo-tri-state-toggle/neo-tri-state-toggle.component';
import { NeoUploadPhotoComponent } from './components/neo-upload-photo/neo-upload-photo.component';
import { EllipsifyDirective } from './custom-directives/ellipsify.directive';
import { ImageDragDirective } from './custom-directives/image-drag.directive';
import { NeoLegacyLinkDirective } from './custom-directives/legacy-link.directive';
import { SearchFilterPipe } from './custom-pipes/custom-search.pipe';
import { FindPipe } from './custom-pipes/find.pipe';
import { ArchivedLabelPipe } from './custom-pipes/archived-label.pipe';
import { VisibleDropdownOptionsPipe } from './custom-pipes/visible-dropdown-options.pipe';
import { HighlightPipe } from './custom-pipes/highlight.pipe';
import { HolidayTypesPipe } from './custom-pipes/holiday-types.pipe';
import { NeoDatePipe } from './custom-pipes/neo-date.pipe';
import { NeoLocalDatePipe } from './custom-pipes/neo-local-date.pipe';
import { NeoLongDateAndTimePipe } from './custom-pipes/neo-long-date-and-time.pipe';
import { NeoLongDatePipe } from './custom-pipes/neo-long-date.pipe';
import { NeoShortDateAndTimePipe } from './custom-pipes/neo-short-date-and-time.pipe';
import { NeoShortDatePipe } from './custom-pipes/neo-short-date.pipe';
import { SortByPipe } from './custom-pipes/neo-sort-by.pipe';
import { NeoTimeWithSecondsPipe } from './custom-pipes/neo-time-with-seconds.pipe';
import { NeoTimeWithoutSecondsPipe } from './custom-pipes/neo-time-without-seconds.pipe';
import { RemoveCommaPipe } from './custom-pipes/remove-comma.pipe';
import { SecureImagePipe } from './custom-pipes/secureImage.pipe';
import { SecurePdfPipe } from './custom-pipes/securePdf.pipe';
import { TimesheetFieldValuePipe } from './custom-pipes/timesheet-field-value.pipe';

@NgModule({
  declarations: [

    // Components
    AlertComponent,
    ConfirmDialogComponent,
    HeaderComponent,
    NeoCardComponent,
    NeoCardListComponent,
    NeoChipComponent,
    NeoFlyoutFilterComponent,
    NeoMediaViewerComponent,
    NeoMultiSelectComponent,
    NeoSignaturePadComponent,
    NeoTableComponent,
    NeoToggleButtonComponent,
    NeoTriStateToggleComponent,
    NeoUploadPhotoComponent,
    // Directives
    EllipsifyDirective,
    ImageDragDirective,

    // Pipes
    FindPipe,
    HolidayTypesPipe,
    NeoDatePipe,
    NeoLocalDatePipe,
    NeoLongDateAndTimePipe,
    NeoLongDatePipe,
    NeoShortDateAndTimePipe,
    NeoShortDatePipe,
    NeoTimeWithSecondsPipe,
    NeoTimeWithoutSecondsPipe,
    RemoveCommaPipe,
    SearchFilterPipe,
    SecureImagePipe,
    SecurePdfPipe,
    TimesheetFieldValuePipe,
    SortByPipe
  ],
  imports: [
    ArchivedLabelPipe,
    VisibleDropdownOptionsPipe,
    HighlightPipe,
    CommonModule,
    A11yModule,
    LayoutModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    // Angular Material Modules
    MatButtonToggleModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDividerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTooltipModule,
    MatSortModule,
    MatToolbarModule,

    // Standalone Components
    NeoButtonComponent,
    NeoLegacyLinkDirective
  ],
  exports: [
    ArchivedLabelPipe,
    VisibleDropdownOptionsPipe,
    HighlightPipe,
    // Components
    AlertComponent,
    ConfirmDialogComponent,
    HeaderComponent,
    NeoButtonComponent,
    NeoCardComponent,
    NeoCardListComponent,
    NeoChipComponent,
    NeoFlyoutFilterComponent,
    NeoMultiSelectComponent,
    NeoSignaturePadComponent,
    NeoTableComponent,
    NeoToggleButtonComponent,
    NeoTriStateToggleComponent,
    NeoUploadPhotoComponent,
    // Directives
    EllipsifyDirective,
    ImageDragDirective,
    NeoLegacyLinkDirective,

    // Pipes
    FindPipe,
    HolidayTypesPipe,
    NeoDatePipe,
    NeoLocalDatePipe,
    NeoLongDateAndTimePipe,
    NeoLongDatePipe,
    NeoShortDateAndTimePipe,
    NeoShortDatePipe,
    NeoTimeWithSecondsPipe,
    NeoTimeWithoutSecondsPipe,
    RemoveCommaPipe,
    SearchFilterPipe,
    SecureImagePipe,
    SecurePdfPipe,
    SortByPipe,
    TimesheetFieldValuePipe,

    // Modules
    LayoutModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatDatepickerModule
  ],
  providers: [
    FindPipe,
    HolidayTypesPipe,
    NeoDatePipe,
    NeoLocalDatePipe,
    NeoLongDateAndTimePipe,
    NeoLongDatePipe,
    NeoShortDateAndTimePipe,
    NeoShortDatePipe,
    NeoTimeWithSecondsPipe,
    NeoTimeWithoutSecondsPipe,
    RemoveCommaPipe,
    SearchFilterPipe,
    SecureImagePipe,
    SecurePdfPipe,
    SortByPipe,
    TimesheetFieldValuePipe,
  ],
})
export class SharedModule { }
